/**
 * Admin Bookmarks — lists the admin's own tagged questions/submissions plus the
 * shared system-pool tags (e.g. studentplacement). Reuses the student-facing
 * BookmarksPage; `useUserTags` resolves against the admin token via ApiProvider,
 * and the backend GET /user/tags merges in SYSTEM_TAG_OWNER's tags for admins.
 */
import { useNavigate } from 'react-router-dom';
import { BookmarksPage } from '@shared-ui/bookmarks';

export function AdminBookmarks() {
  const navigate = useNavigate();
  return (
    <div className="admin-bookmarks-page">
      {/* No heading here — BookmarksPage renders its own PageHeader. */}
      <BookmarksPage
        onQuestionClick={(id) => navigate(`/questions?id=${id}`)}
        onSubmissionClick={(id) => navigate(`/submissions/${id}`)}
      />
    </div>
  );
}
